// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/locales/index.ts"
);
import.meta.hot.lastModified = "1724745731000";
}
// REMIX HMR END

import { SupportedLangs } from '~/types/sys'
import de from './de'
import en from './en'
import fr from './fr'
import it from './it'



export type Dict = Record<SupportedLangs, Record<string, Record<string, string>>>

const dict: Dict = { de, en, fr, it }

export default dict